import { styled, border } from '@elliemae/ds-system';

export const StyledCard = styled.div<{ minHeight: string }>`
  display: flex;
  align-items: center;
  height: fit-content;
  min-height: ${(props) => props.minHeight};
  border: ${(props) => border(props.theme.colors.neutral['100'])};
  border-bottom: ${(props) => border('.5px', props.theme.colors.neutral['500'])};
`;
